module.exports = __webpack_public_path__ + "static/greydoublebcardi-59f74d1fcf6569eac9d52de753fb3dbd.jpeg";